import React from "react";
import PaginaRecursos from "./PaginaRecursos";
import Seleccionarmagatzem, { idMagatzem } from "./Seleccionarmagatzem";
import Detallsmagatzem from "./Detallsmagatzem";

const CONFIG = {
  titol: "Magatzems",
  subtitol: "Magatzems de l'empresa, amb adreça, responsable i contacte.",
  icona: "🏭",
  textNou: "Nou magatzem",
  pestanyaAjuda: "magatzems",
  idDe: idMagatzem,
  Llista: Seleccionarmagatzem,
  Fitxa: Detallsmagatzem,
};

function Magatzems() {
  return <PaginaRecursos config={CONFIG} />;
}

export default Magatzems;
